<template>
  <div>
    <h3 style="text-align: center">产品分类</h3>
    <!--  <div style="margin-top: 20px;">
          <el-button size="mini" type="warning" @click="expandAll" style="margin-left: 10px;">展开所有</el-button>
          <el-button size="mini" type="danger" @click="collapseAll">关闭所有</el-button>
      </div>-->
    <div style="margin-top: 20px;height: 393px;overflow-y: auto">
      <el-tree
        :data="classifyTree"
        ref="classifyTree"
        empty-text="暂无资料"
        node-key="id"
        highlight-current
        :expand-on-click-node="false"
        :default-expand-all="false"
        @node-click="handleNodeClick">
            <span class="custom-tree-node" slot-scope="{ node }" style="width: 100%;">
              <span>
                  <i v-if="node.level  === 1" class="el-icon-suitcase"></i>
                  <i v-else class="el-icon-tickets"></i>
                  {{ node.label }}
              </span>
            </span>
      </el-tree>
    </div>
  </div>

</template>

<script>
import { getProductTypeTree } from '@/api/test/entrust'

export default {
  name: 'classify-select',
  data () {
    return {
      defaultProps: {
        code: 'id'
      },
      classifyTree: []
    }
  },
  mounted () {
    this.initData()
  },
  methods: {
    initData: function () {
      getProductTypeTree().then(res => {
        var result = res.data
        if (result.rtnCode === '0') {
          result.bizData.unshift({ id: '', label: '全部', level: 1, name: '全部', parentId: '', sort: 1 })
          this.classifyTree = result.bizData
          this.$nextTick(() => {
            this.$refs.classifyTree.setCurrentKey(result.bizData[0].id)
          })
          this.handleNodeClick(result.bizData[0])
        } else {
          // eslint-disable-next-line no-unused-expressions
          this.$message.error(result.bizMsg)
        }
      }).catch(() => {
        this.$message.error('菜单树加载失败')
      })
    },
    handleNodeClick (data) {
      this.$emit('change', data.id)
    },
    expandAll () {
      let self = this
      // 转化，抽取目录节点
      let treeList = []
      this.recursion(this.classifyTree, treeList)
      for (let i = 0; i < treeList.length; i++) {
        self.$refs.classifyTree.store.nodesMap[treeList[i].id].expanded = true
      }
    },
    collapseAll () {
      let self = this
      // 转化，抽取目录节点
      let treeList = []
      this.recursion(this.classifyTree, treeList)
      for (let i = 0; i < treeList.length; i++) {
        self.$refs.classifyTree.store.nodesMap[treeList[i].id].expanded = false
      }
    },
    recursion (data, treeList) {
      let self = this
      data.forEach(org => {
        if (!org.isFile) {
          treeList.push(org)
          if (org.children && org.children.length > 0) {
            self.recursion(org.children, treeList)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>
